import { defineMessages } from 'react-intl'

const globalMessages = defineMessages({
  capacity: {
    id: 'global.capacity',
  },
  adult: {
    id: 'global.adult',
  },
  adults: {
    id: 'global.adults',
  },
  child: {
    id: 'global.child',
  },
  children: {
    id: 'global.children',
  },
  childrenAges: {
    id: 'global.childrenAges',
  },
  singularChildrenAges: {
    id: 'search.year',
  },
})

export default globalMessages
